import React from "react";

const Header = () => {
	return (
		<div className="my-10 mx-20">
			<h1 className="font-mochi text-5xl inline-flex">
				Alpaca Image Generator
			</h1>
			<h2 className="mx-5 font-mochi text-3xl inline-flex text-blue-400">
				by Sansan
			</h2>
		</div>
	);
};

export default Header;